<template>
  <div class="login-page">
    <!-- 左侧蓝色区域 -->
    <div class="login-left">
      <div class="blue-bg">
        <div class="welcome-text">
          <h1>Hello!</h1>
          <div class="welcome-cn">欢迎来到中泽科教激光切割教育云平台</div>
          <div class="welcome-en">Welcome to Nakazawa Laser Cutting Education cloud platform</div>
        </div>
        <img class="floating-illustration" src="/static/floating-illustration.png" alt="illustration" />
      </div>
    </div>
    <!-- 右侧登录表单区域 -->
    <div class="login-right">
      <img class="login-logo" src="/static/logo.png" alt="logo" />
      <div class="login-form-container">
        <div class="login-title">代理商端登陆</div>
        <el-card v-if="isLogin" class="login-card">
          <el-form :model="form" ref="form" class="formStyle" :rules="loginRules" label-width="50px">
            <el-form-item label="邮箱" prop="accountNumber">
              <el-input v-model="form.accountNumber" type="email"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input v-model="form.password" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">登陆</el-button>
            </el-form-item>
            <div class="link-container">
              <a @click.prevent="switchToReset" class="link">修改密码</a>
            </div>
          </el-form>
        </el-card>
        <el-card v-if="isResetPassword" class="login-card">
          <h2>修改密码</h2>
          <el-form :model="form" ref="form" class="formStyle" :rules="resetPasswordRules" label-width="80px">
            <el-form-item label="邮箱" prop="accountNumber">
              <el-input v-model="form.accountNumber" type="email"></el-input>
            </el-form-item>
            <el-form-item label="验证码" prop="captcha" required>
              <div style="display: flex; align-items: center;">
                <el-input v-model="form.captcha" placeholder="请输入验证码" style="flex: 1;"></el-input>
                <el-button @click="sendCaptcha" type="primary" style="margin-left: 10px;">发送验证码</el-button>
              </div>
            </el-form-item>
            <el-form-item label="新密码" prop="newPassword">
              <el-input v-model="form.newPassword" type="password"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="form.confirmPassword" type="password"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm">修改密码</el-button>
            </el-form-item>
            <div class="link-container">
              <a @click.prevent="switchToLogin" class="link">返回登录</a>
            </div>
          </el-form>
        </el-card>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      isLogin: true,
      isRegister: false,
      isResetPassword: false,
      sentCaptcha: '', // 用于存储发送的验证码
      form: {
        accountNumber: '',
        password: '',
        captcha: '',
        newPassword: '',
        confirmPassword: '',
        name: '',
        phone: '',
        inviteCode: '',
        agency: ''
      },
      loginRules: {
        accountNumber: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      registerRules: {
        accountNumber: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
        inviteCode: [{ required: true, message: '请输入邀请码', trigger: 'blur' }],
        agency: [{ required: true, message: '请输入机构', trigger: 'blur' }]
      },
      resetPasswordRules: {
        accountNumber: [{ required: true, message: '请输入邮箱', trigger: 'blur' }],
        captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
        newPassword: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
        confirmPassword: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: this.validateConfirmPassword, trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    validateConfirmPassword(rule, value, callback) {
      if (value !== this.form.newPassword) {
        callback(new Error('两次输入密码不一致'));
      } else {
        callback();
      }
    },
    switchToRegister() {
      this.isLogin = false;
      this.isRegister = true;
      this.isResetPassword = false;
    },
    switchToLogin() {
      this.isLogin = true;
      this.isRegister = false;
      this.isResetPassword = false;
    },
    switchToReset() {
      this.isLogin = false;
      this.isRegister = false;
      this.isResetPassword = true;
    },
    sendCaptcha() {
      const formData = new FormData();
      formData.append('to', this.form.accountNumber);
      // 发送 POST 请求
      axios.post('/api/email/send', formData, {
        headers: {
          'Content-Type': 'multipart/form-data' // 设置 Content-Type
        }
      }).then(response => {
        this.sentCaptcha = response.data.data;
        this.$message.success('验证码已发送，请查看您的邮箱！');
      }).catch(error => {
        console.error('发送邮箱时出错:', error);
      });
    },
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          // 在这里添加验证码校验逻辑
          if (this.isRegister && this.form.captcha !== this.sentCaptcha) {
            this.$message.error('验证码错误，请核对！');
            return;
          }
          
          try {
            if (this.isLogin) {
              const response = await this.login();
              // this.$message.success('登录成功！');
              console.log('登录响应:', response);
            } else if (this.isRegister) {
              // 确保邀请码不为空
              if (!this.form.inviteCode) {
                this.$message.error('邀请码不能为空！');
                return;
              }
              const response = await this.register();
              // 注册成功后切换到登录页面
              if (response.success) {
                this.switchToLogin();
              }
            } else if (this.isResetPassword) {
              const response = await this.resetPassword();
              // this.$message.success('密码修改成功，请登录。');
              console.log('修改密码响应:', response);
              this.switchToLogin();
            }
          } catch (error) {
            this.$message.error(error.message || '操作失败，请重试！');
          }
        } else {
          console.log('表单验证失败');
          this.validateFormFields();
        }
      });
    },
    validateFormFields() {
      if (this.isRegister) {
        const { accountNumber, newPassword, name, phone, inviteCode, agency, captcha } = this.form;
        if (!accountNumber || !newPassword || !name || !phone || !inviteCode || !agency || !captcha) {
          this.$message.error('请填写所有必填字段！');
        }
      } else if (this.isResetPassword) {
        const { newPassword, confirmPassword } = this.form;
        if (newPassword !== confirmPassword) {
          this.$message.error('新密码与确认密码不一致！');
        }
      }
    },

    async login() {
      try {
        const response = await axios.post('/api/agentUsers/login', {
          accountNum: this.form.accountNumber,
          password: this.form.password
        });
        
        if (response.data.success) {
          this.$message.success('登录成功！')
          localStorage.setItem('agentUserInfo', JSON.stringify(this.form.accountNumber));
          this.$router.push('/index'); // 跳转到首页
        } else {
          this.$message.error(response.data.message || '登录失败，请重试！'); // 处理登录失败的情况
        }
        
        return response.data; // 返回响应数据
      } catch (error) {
        this.$message.error('登录请求出错：' + (error.response?.data?.message || error.message)); // 处理请求错误
        console.error('登录错误:', error);
      }
    },
    async register() {
      const response = await axios.post('/api/auth/register', {
        accountNumber: this.form.accountNumber,
        password: this.form.newPassword,
        userName: this.form.name,  
        phone: this.form.phone,
        invitationCode: this.form.inviteCode,  // 确保变量名一致
        institutionName: this.form.agency,
      });
      if (response.data.success) {
        this.$message.success('注册成功！请登录。');
        this.switchToLogin(); // 只有注册成功后才切换到登录
      } else {
        // 处理用户已存在和邀请码错误的情况
        this.$message.error(response.data.msg );
      }
      return response.data;
    },
    async resetPassword() {
      const response = await axios.post('/api/reset-password', {
        email: this.form.accountNumber,
        newPassword: this.form.newPassword,
        captcha: this.form.captcha
      }).then(()=>{
        if(response.data.success){
          this.$router.push('/index')
        }
      });
      return response.data;
    }
  }
};
</script>

<style scoped>
.login-page {
  display: flex;
  width: 100vw;
  height: 100vh;
  background: #f7f9fb;
  overflow: hidden;
}
.login-left {
  flex: 1.2;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 400px;
  background: transparent;
}
.blue-bg {
  width: 100%;
  height: 100%;
  background: linear-gradient(120deg, #4b80e4 80%, #4b80e4 100%);
  clip-path: polygon(0 0, 100% 0, 75% 100%, 0% 100%);
  position: absolute;
  left: 0; top: 0; bottom: 0; right: 0;
  z-index: 1;
  background-image: url('/static/login-illustration.png');
  background-repeat: no-repeat;
  background-position: left top;
  background-size: 800px auto;
}
.welcome-text {
  position: absolute;
  top: 13%;
  left: 10%;
  color: #fff;
  z-index: 2;
}
.welcome-text h1 {
  font-size: 3.5rem;
  font-weight: 700;
  margin-bottom: 10px;
}
.welcome-cn {
  font-size: 1.3rem;
  margin-bottom: 4px;
}
.welcome-en {
  font-size: 0.95rem;
  opacity: 0.9;
}
.login-right {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
  background: #fff;
}
.login-logo {
  position: absolute;
  top: 40px;
  right: 60px;
  width: 120px;
  height: auto;
  z-index: 3;
}
.login-form-container {
  width: 500px;
  height: 400px;
  margin-top: -80px;
  margin-right: 320px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.login-title {
  font-size: 1.7rem;
  font-weight: 500;
  margin-bottom: 30px;
  color: #333333;
  text-align: center;
}
.login-card {
  width: 100%;
  padding: 24px 20px 10px 20px;
  border-radius: 16px;
  background: #fff;
  box-shadow: none;
}
.formStyle {
  margin-top: 20px;
}
.link-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
.link {
  color: #4b80e4;
  text-decoration: none;
  cursor: pointer;
  font-size: 0.98rem;
}
.link:hover {
  color: #1a4d8f;
}
@media (max-width: 900px) {
  .login-page { flex-direction: column; }
  .login-left, .login-right { min-width: 100vw; }
  .login-right { padding-top: 20px; }
  .login-form-container { width: 90vw; }
  .login-logo { right: 20px; width: 80px; }
}
.floating-illustration {
  position: absolute;
  bottom: 20%;
  right: 35%;
  width: 55%;
  height: auto;
  z-index: 2;
}
</style>
